module.exports = __webpack_public_path__ + "static/media/tianshangshan_package.17008739.png";